import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_4_11
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-4-11',
    templateUrl: './exemption_4_11.component.html',
    styleUrls: ['./exemption_4_11.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_4_11Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_4_11;

  reasonTypes: string[] = ['',
    'Cleaning or ventilating outside a location designated by the Harbour Master'
  ]

  dangerousGoods?: DangerInformation
  portVisitUtils = PortvisitUtils;
}

